import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    type: {
      title: 'Typ',
      type: 'string',
      fieldRequired: true
    },
    templateId: {
      title: 'Id wzoru',
      type: 'number',
      fieldRequired: false
    },
    stageId: {
      title: 'Etap',
      type: 'number',
      fieldRequired: false
    },
    start: {
      title: 'Status początkowy',
      type: 'boolean'
    },
    color: {
      title: 'Kolor',
      type: 'string',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
